import { useEffect, useState } from 'react';
import cn from 'clsx';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';

import styles from './CyclingLoadingText.module.css';

const LOADING_MESSAGES = [
  'search.aiSearch.loadingAnimation.line1',
  'search.aiSearch.loadingAnimation.line2',
  'search.aiSearch.loadingAnimation.line3',
] as const;

const TYPING_SPEED = 30; // milliseconds per character
const PAUSE_AFTER_COMPLETE = 500; // pause before switching to next message

export const CyclingLoadingText = ({ className, 'data-testid': dataTestId }: { className?: string; 'data-testid'?: string }) => {
  const { t } = useAppContext();
  const [messageIndex, setMessageIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    const currentMessage = t(LOADING_MESSAGES[messageIndex]!);

    if (isTyping && displayedText.length < currentMessage.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(currentMessage.slice(0, displayedText.length + 1));
      }, TYPING_SPEED);
      return () => clearTimeout(timeout);
    } else if (displayedText.length === currentMessage.length) {
      setIsTyping(false);
      const timeout = setTimeout(() => {
        setMessageIndex((prevIndex) => (prevIndex + 1) % LOADING_MESSAGES.length);
        setDisplayedText('');
        setIsTyping(true);
      }, PAUSE_AFTER_COMPLETE);
      return () => clearTimeout(timeout);
    }
  }, [displayedText, messageIndex, isTyping, t]);

  return (
    <div className={cn(styles.overlay, className)} data-testid={dataTestId}>
      <span className={styles.gradientLoadingText}>{displayedText}</span>
    </div>
  );
};
